<template>
	<div id="stars" class="stars" v-if="ptInitData.reviewFlg == 1">
		<template v-for="(reviewList, idx) in ptInitData.totalReviewRank">
			<template v-if="reviewList.TOTALRANKAVG >= 1 && reviewList.TOTALRANKAVG <= 10">
				<span class="startNum" :key="idx">0.5</span>
				<img class="imgReview" src="../img/icons/demo/star_0_5.png" :key="idx">
			</template>
			<template v-if="reviewList.TOTALRANKAVG >= 11 && reviewList.TOTALRANKAVG <= 20">
				<span class="startNum" :key="idx">1.0</span>
				<img class="imgReview" src="../img/icons/demo/star_1.png" :key="idx">
			</template>
			<template v-if="reviewList.TOTALRANKAVG >= 21 && reviewList.TOTALRANKAVG <= 30">
				<span class="startNum" :key="idx">1.5</span>
				<img class="imgReview" src="../img/icons/demo/star_1_5.png" :key="idx">
			</template>
			<template v-if="reviewList.TOTALRANKAVG >= 31 && reviewList.TOTALRANKAVG <= 40">
				<span class="startNum" :key="idx">2.0</span>
				<img class="imgReview" src="../img/icons/demo/star_2.png" :key="idx">
			</template>
			<template v-if="reviewList.TOTALRANKAVG >= 41 && reviewList.TOTALRANKAVG <= 50">
				<span class="startNum" :key="idx">2.5</span>
				<img class="imgReview" src="../img/icons/demo/star_2_5.png" :key="idx">
			</template>
			<template v-if="reviewList.TOTALRANKAVG >= 51 && reviewList.TOTALRANKAVG <= 60">
				<span class="startNum" :key="idx">3.0</span>
				<img class="imgReview" src="../img/icons/demo/star_3.png" :key="idx">
			</template>
			<template v-if="reviewList.TOTALRANKAVG >= 61 && reviewList.TOTALRANKAVG <= 70">
				<span class="startNum" :key="idx">3.5</span>
				<img class="imgReview" src="../img/icons/demo/star_3_5.png" :key="idx">
			</template>
			<template v-if="reviewList.TOTALRANKAVG >= 71 && reviewList.TOTALRANKAVG <= 80">
				<span class="startNum" :key="idx">4.0</span>
				<img class="imgReview" src="../img/icons/demo/star_4.png" :key="idx">
			</template>
			<template v-if="reviewList.TOTALRANKAVG >= 81 && reviewList.TOTALRANKAVG <= 90">
				<span class="startNum" :key="idx">4.5</span>
				<img class="imgReview" src="../img/icons/demo/star_4_5.png" :key="idx">
			</template>
			<template v-if="reviewList.TOTALRANKAVG >= 91 && reviewList.TOTALRANKAVG <= 100">
				<span class="startNum" :key="idx">5.0</span>
				<img class="imgReview" src="../img/icons/demo/star_5.png" :key="idx">
			</template>
			<!-- レビュー投稿ボタン 商品詳細から投稿オプション(50661)が入っているとき有効 -->
			<template>
				<a class="postReview" :key="idx"
					v-if="ptInitData.loginKbn && ptInitData.productInfo.REVIEW_NUM == 1 && !(ptInitData.productInfo.FORM_LP_FLG == 1 && isLp)"
					@click="pt461reviewList(pt125ReqModel.sItemNo)">{{ $t('pt125.labels.postReview') }}</a>
			</template>
		</template>
	</div>
</template>
<script>
import SiteConstants from 'assets/const/SiteConstants.json';

export default {
	name: 'starsParts',
	props: {
		ptInitData: {
			type: Object,
			default: null,
		},
		pt125ReqModel: {
			type: Object,
			default: null,
		},
		isLp: {
			type: Boolean,
			default: false
		}
	},
	data: () => {
		return {
			SiteConstants,
		}
	},
	methods: {
		/*
		* レビュー一覧画面へ
		*/
		pt461reviewList: function (_itemCd) {
			var _this = this;
			_this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 83, itemCd: _itemCd } });
		},
	}
}
</script>